var map = {
	"./featured-blogs.de-CH.json": 1465,
	"./featured-blogs.de-DE.json": 1466,
	"./featured-blogs.en-CA.json": 1467,
	"./featured-blogs.en-GB.json": 1468,
	"./featured-blogs.en-IN.json": 1469,
	"./featured-blogs.en-ME.json": 1470,
	"./featured-blogs.en-US.json": 1471,
	"./featured-blogs.es-EM.json": 1472,
	"./featured-blogs.es-ES.json": 1473,
	"./featured-blogs.fr-BE.json": 1474,
	"./featured-blogs.fr-CA.json": 1475,
	"./featured-blogs.fr-CH.json": 1476,
	"./featured-blogs.nl-BE.json": 1477,
	"./featured-blogs.nl-NL.json": 1478,
	"./featured-blogs.pl-PL.json": 1479,
	"./featured-blogs.pt-BR.json": 1480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1464;